const byId = (list) => {
  const map = {};
  list.forEach((l) => {
    map[l.id] = l;
  });
  return map;
};

/**
 * Joins role and role type
 */
export const getDisplayRoles = (roles, roleTypes, roleIds) => {
  const rolesById = byId(roles);
  const roleTypesById = byId(roleTypes);
  return (roleIds || []).map((rId) => {
    const role = rolesById[rId] || {};
    const roleTypeId = role.role_type_id;
    return {
      ...role,
      type: roleTypesById[roleTypeId] || {},
    };
  });
};

export const getAllDisplayRoles = (roles, roleTypes, orgs) => {
  const roleTypesById = byId(roleTypes);
  const orgsById = byId(orgs);
  return roles.map((role) => ({
    ...role,
    type: roleTypesById[role.role_type_id] || {},
    org: orgsById[role.org_id] || {},
  }));
};
